/* Auto-hoogte voor de NOIZEZZ Fit Check iframe(s).
   De tool in het iframe stuurt {type:"noizezz-fitcheck-height", height}. */
(function () {
  window.addEventListener('message', function (e) {
    if (!e.data || e.data.type !== 'noizezz-fitcheck-height') return;
    var frames = document.querySelectorAll('iframe.nz-fitcheck__frame');
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].contentWindow === e.source) {
        var h = parseInt(e.data.height, 10);
        var cur = parseInt(frames[i].style.height, 10) || 0;
        if (h > 0 && Math.abs(h - cur) > 2) frames[i].style.height = h + 'px';
        break;
      }
    }
  });
})();
